import { Formik, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { useNavigate, useParams } from 'react-router-dom';
import api from '@/services/api';
import axios from 'axios';
import { useSnackbar } from 'notistack';
import TextField from '@/components/Input/TextField';
import { Button } from '@/components/Button';
import { Check } from 'lucide-react';
import { Caption, Title } from '../StepOne/style';
import Stack from '@mui/material/Stack';
import { useTranslation } from 'react-i18next';

function StepTwo() {
  const { t } = useTranslation();
  const params = useParams();
  const recoveryToken = params['recovery-token'];
  const navigate = useNavigate();

  const initialValues = {
    password: '',
    confirmPassword: '',
  };
  const { enqueueSnackbar } = useSnackbar();

  // Esquema de validação
  const RecoveryPasswordSchema = Yup.object().shape({
    password: Yup.string()
      .min(8, t('forgetPassword.minPassword'))
      .required(t('forgetPassword.requirePassword')),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref('password')], t('forgetPassword.matchPassword'))
      .required(t('forgetPasswod.checkPassowrd')),
  });

  const handleRecovery = async (values: {
    password: string;
    confirmPassword: string;
  }) => {
    try {
      console.log(recoveryToken);
      const response = await api.post(
        `/users/reset-password/${recoveryToken}`,
        {
          password: values.password,
        }
      );
      console.log(response);
      if (response.status === 204) {
        enqueueSnackbar(t('forgetPassword.checkInbox'), {
          variant: 'success',
        });
        navigate('/');
      }
    } catch (error) {
      if (axios.isAxiosError(error)) {
        if (error.response) {
          enqueueSnackbar(error.response.data?.detail, { variant: 'error' });
        }
      }
    }
  };
  return (
    <Formik
      initialValues={initialValues}
      validationSchema={RecoveryPasswordSchema}
      onSubmit={handleRecovery}
    >
      {({ values, touched, errors, handleChange, submitForm }) => (
        <>
          <div>
            <Title>{t('forgetPassword.recoverPassword')}</Title>
            <Caption variant="caption">
              {t('forgetPassword.enterNewPassword')}
            </Caption>
          </div>
          <Stack spacing={3} width={1}>
            <TextField
              placeholder={t('forgetPassword.newPassword')}
              name="password"
              id="password"
              value={values.password}
              onChange={handleChange}
              type="password"
              error={touched.password && Boolean(errors.password)}
              helperText={<ErrorMessage name="password" component="div" />}
            />

            <TextField
              placeholder={t('forgetPassword.confirmPassword')}
              name="confirmPassword"
              id="confirmPassword"
              value={values.confirmPassword}
              onChange={handleChange}
              type="password"
              error={touched.confirmPassword && Boolean(errors.confirmPassword)}
              helperText={
                <ErrorMessage name="confirmPassword" component="div" />
              }
            />
            <Button
              variant="default"
              type="submit"
              onClick={submitForm}
              startIcon={<Check />}
            >
              {t('forgetPassword.changePassword')}
            </Button>
          </Stack>
        </>
      )}
    </Formik>
  );
}

export default StepTwo;
